<template>
  <div style="margin: 24px 12px;">
    <el-input
      type="textarea"
      placeholder="请输入评论内容"
      v-model="commentMsg"
      maxlength="500"
      :autosize="{ minRows: 3, maxRows: 6}"
      show-word-limit
    ></el-input>
    <div style="text-align: right;margin-top: 12px;">
      <el-button :size="size" :disabled="isDisable" :loading="loading" @click="toCommit">提交</el-button>
    </div>
  </div>
</template>
<script>
import xyAPI from '@/api/xyAPI'
import loadData from '@/https/loadData'
import xy_config from '@/config/xy_config'
export default {
  name: 'ArticleDetailComment',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      commentMsg: '',
      size: 'info',
      isDisable: true,
      loading: false
    }
  },
  methods: {
    async toCommit () {
      const _that = this
      const tokenCookie = this.$cookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        _that.$message({
          message: '登录后操作',
          duration: 1000,
          onClose: () => {
            window.location.href = '../login/login.html?to=' + escape(window.location.href)
          }
        })
        return
      }
      // 提交评论
      try {
        _that.loading = true
        const res = await loadData(xyAPI.setLeaveMessage, { articleid: _that.item.id, leavecontent: _that.commentMsg })
        if (res && String(res.code) === '0') {
          _that.commentMsg = ''
          _that.$message('操作成功')
          _that.$emit('submitComment')
        } else {
          _that.$message(res && res.msg ? res.msg : '操作失败')
        }
      } catch (error) {
        this.$message('操作失败')
      } finally {
        _that.loading = false
      }
    }
  },
  watch: {
    commentMsg () {
      if (this.commentMsg) {
        this.size = 'default'
        this.isDisable = false
      } else {
        this.size = 'info'
        this.isDisable = true
      }
    }
  }
}
</script>